import React from 'react';

import { Box, Typography } from '@mui/material';

import type { Tuple } from '@clearverify/types';

import { Button } from 'src/components/common';
import { Field, Form, RadioGroupField, RadioGroupOption } from 'src/components/finalForm';

export const RadioInputSection: React.FC = () => {
  return (
    <Box component="section">
      <Typography variant="h3">Radio Input</Typography>

      <Box mt={2}>
        <Form onSubmit={submitHandler} initialValues={initialValue} subscription={{ dirty: true }}>
          {({ form, dirty }) => (
            <React.Fragment>
              <Box>
                <Field
                  name={FormFieldId.simpleRadioField}
                  component={RadioGroupField}
                  label="Simple radio"
                  options={options}
                />
              </Box>

              <Box>
                <Field
                  name={FormFieldId.selectedRadioField}
                  component={RadioGroupField}
                  label="Selected radio"
                  options={options}
                />
              </Box>

              <Box>
                <Field
                  name={FormFieldId.disabledRadioField}
                  component={RadioGroupField}
                  label="Disabled radio"
                  options={options}
                  disabled
                />
              </Box>

              <Box>
                <Field
                  name={FormFieldId.selectedDisabledRadioField}
                  component={RadioGroupField}
                  label="Disabled radio"
                  options={options}
                  disabled
                />
              </Box>

              <Box mt={2}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => form.restart()}
                  disabled={!dirty}
                >
                  Reset
                </Button>
              </Box>
            </React.Fragment>
          )}
        </Form>
      </Box>
    </Box>
  );
};

const options: Tuple<RadioGroupOption, 2> = [
  {
    value: '1',
    label: 'Option 1',
  },
  {
    value: '2',
    label: 'Option 2',
  },
];

enum FormFieldId {
  simpleRadioField = 'simpleRadioField',
  selectedRadioField = 'selectedRadioField',
  disabledRadioField = 'disabledRadioField',
  selectedDisabledRadioField = 'selectedDisabledRadioField',
}

const initialValue = {
  [FormFieldId.simpleRadioField]: [],
  [FormFieldId.selectedRadioField]: [options[0].value],
  [FormFieldId.disabledRadioField]: [],
  [FormFieldId.selectedDisabledRadioField]: [options[1].value],
};

const submitHandler = () => undefined;
